import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isString, isUndefined } from 'lib';
import { useTranslation } from 'react-i18next';
import { StyledError } from './Error.styles';

const formatMessage = (msg = '', external = false) => {
  return `${external ? '' : 'errors.'}${msg
    ?.toString()
    ?.trim()
    ?.toLowerCase()
    ?.replace(/[ ]/g, '_')}`;
};

const error401 = (message, status_code, external = false) => {
  if (external) {
    // به کاربر خطا ی عدم دسترسی نمایش بده
    return {
      message: formatMessage(message),
      status_code,
      external,
    };
  }
};

const error422 = (data = {}) => {
  const { errors = {}, status_code, external = false } = data;
  if (errors) {
    const errorsObj = {};
    Object.entries(errors).forEach(([key, value]) => {
      const temp = value.map((msg) => {
        return formatMessage(msg);
      });
      errorsObj[formatMessage(key)] = temp;
    });
    return { errors: errorsObj, status_code, external };
  }
  return {};
};

const exteraErrors = (message, status_code, external = false) => {
  if (external)
    return { message: formatMessage(message, external), status_code, external };
  return { message: formatMessage(status_code), status_code, external };
};

const uiErrors = (errors = {}) => {
  const { data, meta } =
    (errors?.response?.data?.errors
      ? errors?.response?.data?.errors
      : errors?.response) || {};

  // eslint-disable-next-line prefer-const
  let { message, status_code, external } = data || {};
  //   اگر ارور از نوع فقط متن بود - حالت‌های قدیدی ارور
  if (isString(message) && isUndefined(status_code) && isUndefined(external)) {
    return {
      message: message,
      status_code: errors.response.status,
      external: false,
    };
  }

  if (external) {
    const { code = 0, platform = '' } = meta || {};
    message = `${platform}.error_code.${code}`;
  }

  switch (status_code) {
    case 401:
      // عدم دسترسی
      return error401(message, status_code, external);
    case 422:
      // اطلاعات ارسال شده صحیح نیست
      return error422(data);

    default:
      // خطای سمت سرور 500
      // 403 - 404
      // و تمام ارور های تعریف نشده که نیازی به ساختار خاص ندارند
      return exteraErrors(message, status_code, external);
  }
};

const UiErrors = ({ errors = {}, noCollapse = false }) => {
  // نرمال سازی خطای بک اند در فرانت
  const error = uiErrors(errors);
  switch (error.status_code) {
    case 422:
      return (
        <StyledError>
          <Collapse statusCode={error.status_code} noCollapse={noCollapse}>
            <Wrapper422 error={error} />
          </Collapse>
        </StyledError>
      );

    default:
      // 401 , 500
      return (
        <StyledError>
          <Collapse statusCode={error.status_code} noCollapse={noCollapse}>
            <WrapperMessage error={error} />
          </Collapse>
        </StyledError>
      );
  }
};

UiErrors.propTypes = {
  errors: PropTypes.object,
  noCollapse: PropTypes.bool,
};

const WrapperMessage = ({ error = {} }) => {
  return <div>{error.message}</div>;
};
WrapperMessage.propTypes = {
  error: PropTypes.object,
};

const Wrapper422 = ({ error = {} }) => {
  // خطا‌ها به صورت آبجکت
  const errorList = error?.errors;

  // کلیدهای خطا
  const errorKeys = Object.keys(errorList);

  // لیست خطاها به تفکیک هر کلید
  const errorComponent = errorKeys?.map((key) => {
    return (
      <ul className='ui-errors-list' key={key}>
        <li className='ui-errors-list-title'>{key}</li>
        {errorList?.[key]?.map((item, i) => {
          return <li key={i}>{item}</li>;
        })}
      </ul>
    );
  });

  if (error.status_code === 422) {
    return errorComponent;
  }

  return null;
};
Wrapper422.propTypes = {
  error: PropTypes.object,
};

const Collapse = ({ children, statusCode, noCollapse = false }) => {
  const { t } = useTranslation();
  const [toggleCollapse, setToggleCollapse] = useState(false);

  // اگر بدون کولپس بود
  if (noCollapse) return children;

  // اگر کولپس بود
  return (
    <div className='ui-errors' onClick={() => setToggleCollapse((e) => !e)}>
      <span className='ui-errors-lable'>
        {t('common:errorOccurred', { status: statusCode })}
      </span>
      <span className='ui-errors-more'>
        {t('common:details')}
        <i className={`icon icon-arrow-${toggleCollapse ? 'up' : 'down'}`}></i>
      </span>
      {toggleCollapse && <div className='ui-errors-list'>{children}</div>}
    </div>
  );
};

Collapse.propTypes = {
  children: PropTypes.node,
  statusCode: PropTypes.number,
  noCollapse: PropTypes.bool,
};

export { uiErrors, UiErrors };
